module.exports = __webpack_public_path__ + "./img/1.ae62a1de.png";